import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { APIV2 } from "services/ApiServiceV2";
import { getFavProducts } from "./productSlice";

export const getCart = createAsyncThunk(
  "cart/getCart",
  async (arg, thunkAPI) => {
    if (
      thunkAPI.getState().StoredutilsSlice?.guestUserId ||
      thunkAPI.getState().AuthReducer.userId
    ) {
      return await APIV2(
        `v1/cart/${
          thunkAPI.getState().AuthReducer.userId ||
          thunkAPI.getState()?.StoredutilsSlice?.guestUserId
        }`,
        "GET",
        arg,
        "JAVA"
      )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          console.log("err", err);
          return err;
        });
    } else {
      return null;
    }
  }
);

export const addToCart = createAsyncThunk(
  "cart/addToCart",
  async (arg, thunkAPI) => {
    return await APIV2(
      `v1/cart/add?productId=${arg?.productId}&quantity=${
        arg?.qty
      }&productSize=${arg?.size}&userId=${
        thunkAPI.getState().AuthReducer.userId ||
        thunkAPI.getState()?.StoredutilsSlice?.guestUserId
      }`,
      "POST",
      arg,
      "JAVA"
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const addNewAddress = createAsyncThunk(
  "cart/addNewAddress",
  async (arg, thunkAPI) => {
    return await APIV2(`user/v1/user-profile/address`, "POST", arg, "JAVA")
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const updateCartProduct = createAsyncThunk(
  "cart/updateCartProduct",
  async (arg, thunkAPI) => {
    return await APIV2(
      `v1/cart/update?productId=${arg?.productId}&quantity=${
        arg?.quantity
      }&userId=${
        thunkAPI.getState().AuthReducer.userId ||
        thunkAPI.getState()?.StoredutilsSlice?.guestUserId
      }${arg?.size ? `&productSize=${arg?.size}` : ""}`,
      "PUT",
      {},
      "JAVA"
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const addToFavourite = createAsyncThunk(
  "cart/addToFavourite",
  async (arg, thunkAPI) => {
    return await APIV2(`favouriteProducts`, "POST", arg)
      .then((res) => {
        thunkAPI.dispatch(getFavProducts());
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const deleteFavourite = createAsyncThunk(
  "cart/deleteFavourite",
  async (arg, thunkAPI) => {
    return await APIV2(
      `favouriteProducts/${arg?.userId}/${arg?.productId}`,
      "DELETE",
      {},
      "NODE"
    )
      .then((res) => {
        thunkAPI.dispatch(getFavProducts());
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const triggerPdpAbondoned = createAsyncThunk(
  "cart/triggerPdpAbondoned",
  async (arg, thunkAPI) => {
    return await APIV2(
      `v1/analytics/user/trigger/pdp-event?productId=${arg?.productId}&userId=${
        thunkAPI.getState().AuthReducer.userId
      }`,
      "POST",
      arg,
      "JAVA"
    )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
);

let initialState = {
  cart: null,
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCart: (state, action) => {
      state.cart = action.payload;
    },
    resetCartSlice: (state) => {
      state.cart = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCart.pending, (state, action) => {})
      .addCase(getCart.fulfilled, (state, action) => {
        if (
          [200].includes(action?.payload?.status) &&
          action?.payload?.data?.cart
        ) {
          state.cart = action?.payload?.data;
        }
      })
      .addCase(getCart.rejected, (state, action) => {
        console.log("getCart api error", action?.payload);
      });
  },
});

export const { setCart, resetCartSlice } = cartSlice.actions;

export default cartSlice.reducer;
